import { render, staticRenderFns } from "./MailTemplateNav.vue?vue&type=template&id=3a5480f7&scoped=true"
import script from "./MailTemplateNav.vue?vue&type=script&lang=js"
export * from "./MailTemplateNav.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateNav.vue?vue&type=style&index=0&id=3a5480f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5480f7",
  null
  
)

export default component.exports